import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { DONATION_DETAIL_QUERY } from "../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match, location }) => {
  const { data, loading } = useQuery(DONATION_DETAIL_QUERY, {
    variables: { id: match.params.id }
  });

  if (loading === true) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  } else if (!loading && data && data.AdminDonationDetail) {
    console.log(data);
    const {
      AdminDonationDetail: {
        id,
        DonationCategory,
        title,
        contents,
        planner,
        plannerTel,
        plannerUseSNS,
        plannerSNS,
        goalAmount,
        startDate,
        endDate,
        coverImg,
        detailImg,
        totalDRM,
        totalDNC,
        commonStatus,
        createdAt,
        updatedAt,
        manager
      }
    } = data;
    return (
      <Presenter
        history={history}
        match={match}
        location={location}
        id={id}
        DonationCategory={DonationCategory}
        title={title}
        contents={contents}
        planner={planner}
        plannerTel={plannerTel}
        plannerUseSNS={plannerUseSNS}
        plannerSNS={plannerSNS}
        goalAmount={goalAmount}
        commonStatus={commonStatus}
        startDateAt={startDate}
        endDateAt={endDate}
        createdAt={createdAt}
        updatedAt={updatedAt}
        coverImg={coverImg}
        detailImg={detailImg}
        totalDRM={totalDRM}
        totalDNC={totalDNC}
        manager={manager}
      />
    );
  }
});
